<template>

  <div>
    <template v-if="interventions.length">
      <v-tabs v-model="tab">
        <v-tab v-for="intervention of interventions" :key="intervention.id">
          {{ intervention.driveStartAt | date }}
          <a @click.stop.prevent="archive(intervention)" class="intervention-archive" v-if="canArchive">
            <font-awesome-icon icon="times"></font-awesome-icon>
          </a>
        </v-tab>
        <v-btn text @click="create()" v-if="!issue.closed">
          <font-awesome-icon icon="plus-circle" size="lg"></font-awesome-icon>
          {{ $t('interventions.add') }}
        </v-btn>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="intervention in interventions" :key="intervention.id">
          <v-card>
            <intervention-form :intervention="intervention" :issue="issue" @change="save($event)"></intervention-form>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>

    <div v-if="!interventions.length" class="no-interventions">
      <no-data>
        <div>{{ $t('issues.no-interventions') }}</div>
        <div>
          <v-btn text color="primary" @click="create()">
            {{ $t('issues.create-new') }}
          </v-btn>
        </div>
      </no-data>
    </div>
  </div>

</template>

<script>
  import i18n from '../../../i18n'
  import NoData from '../../shared/no-data'
  import InterventionForm from './intervention-form'

  export default {
    name: 'interventions-tabs',
    components: {InterventionForm, NoData},
    props: [ 'issue', 'interventions' ],

    data () {
      return {
        tab: null
      }
    },

    computed: {
      canArchive () {
        return (this.$can('manager') || this.$can('worker')) && !this.issue.closed
      },
    },

    methods: {
      async save (intervention) {
        await this.$store.dispatch('updateItem', { modelName: 'interventions', item: intervention })
        this.$emit('change', { intervention: intervention, route: false, spinner: false })
      },

      async create () {
        const response = await this.$store.dispatch('solveIssue', { issue: this.issue })
        const intervention = response.data

        if (this.issue.id)
          this.$emit('change', { intervention: intervention, route: false, spinner: false})
        else
          this.$router.push({ name: `issues/id`, params: { id: response.data.issue.id, interventionId: intervention.id }})
      },

      async archive (intervention) {
        const result = await this.$dialog.confirm({
          title: this.$t('delete-question'),
          text: this.$t('deleted-item-can-be-restored-notice'),
          actions: {
            true: {text: i18n.t('yes'), color: 'red'},
            false: {text: i18n.t('no'), color: 'black'}
          }
        })

        if (result) {
          await this.$store.dispatch('destroyItem', { model: { name: 'interventions' }, id: intervention.id })
          this.$emit('change', { intervention: intervention, route: false, spinner: false})
        }
      },
    }
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables.scss';

  ::v-deep {
    .v-item-group,
    .v-tabs > .v-tabs-bar {
      background: none;
    }

    $tab-background: lighten($color-light-gray, 0.5%);

    .v-tabs {
      transform: translateX(-5px);
      z-index: 1;
      position: relative;

      .v-tabs-bar__content {
        padding-left: 5px;
      }

      .v-tabs-slider-wrapper {
        display: none;
      }

      .v-btn {
        margin-top: 7px;

        svg {
          margin-right: 5px;
        }
      }

      .v-tab {
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        margin: 5px 5px 0 0;
        border-bottom: 1px solid $color-gray;
        background-color: $color-light-gray;
        border-top-left-radius: $border-radius;
        border-top-right-radius: $border-radius;

        &.v-tab--active {
          border-bottom: none;
          background-color: $tab-background;
        }
      }
    }

    .v-card {
      padding: $spacing-default;
      background-color: $tab-background;
    }
  }

  .intervention-archive {
    margin-left: 5px;

    svg {
      color: lighten($color-warn, 15%);
    }
  }

  .no-interventions {
    height: 200px;
  }

</style>
